import React from 'react';
import Footer from './footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaAngleRight } from "react-icons/fa";

function ExamDetails() {
    const navigate = useNavigate();
    const { state } = useLocation();


    function decodeHTML(html) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    function cleanHTML(html) {
        return html.replace(/<\/?p>/g, "");
    }


    return (
        <div className='scscholmain-container'>
            <div className="cl-hero-banner" style={{ height: "92px" }}>
                <div className="cl-hero-pattern"></div>
                <div className="cl-hero-text">
                    <h2>Exam Details</h2>
                </div>

                <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <b>Exam Lists</b> </span>
            </div>

            <div className="sccontainer-st">
                <div className='headofexdet-st'>
                    <img src={state?.icon} alt={state?.title} className='headimg-exst' />
                    <h2>{state?.title}</h2>
                </div>

                <ul className="nav nav-tabs" id="examTab" role="tablist">

                    <li className="nav-item">
                        <button
                            className="nav-link nav-link-st active"
                            data-bs-toggle="tab"
                            data-bs-target="#about"
                        >
                            About
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className="nav-link nav-link-st"
                            data-bs-toggle="tab"
                            data-bs-target="#eligibility"
                        >
                            Eligibility
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className="nav-link nav-link-st"
                            data-bs-toggle="tab"
                            data-bs-target="#contact"
                        >
                            Contact
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className="nav-link nav-link-st"
                            data-bs-toggle="tab"
                            data-bs-target="#more"
                        >
                            More
                        </button>
                    </li>

                </ul>

                <div className="tab-content border border-top-0 p-4">

                    <div className="tab-pane fade show active" id="about">
                        <h3>About (Brief description)</h3>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(decodeHTML(state?.description || ""))
                            }}
                        />
                    </div>

                    <div className="tab-pane fade" id="eligibility">
                        <h3>Eligibility</h3>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(decodeHTML(state?.eligibility || ""))
                            }}
                        />
                    </div>

                    <div className="tab-pane fade" id="contact">
                        <h3>Contact</h3>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(decodeHTML(state?.contact_details || ""))
                            }}
                        />
                    </div>

                    <div className="tab-pane fade" id="more">
                        <h3>Official Website</h3>
                        <a href={state?.more||"#"}>{state?.more || ""}</a>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    )
}

export default ExamDetails
